import { render, staticRenderFns } from "./Carousel1.vue?vue&type=template&id=1eae6832&scoped=true&"
import script from "./Carousel1.vue?vue&type=script&lang=js&"
export * from "./Carousel1.vue?vue&type=script&lang=js&"
import style0 from "./Carousel1.vue?vue&type=style&index=0&id=1eae6832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae6832",
  null
  
)

export default component.exports